import { NodeModel } from '@minoru/react-dnd-treeview';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    openWorkshiftModal: (
        startDate: string | number,
        endDate: string | number,
        employee: NodeModel[],
        isExceptional: boolean
    ) => void;
};

export const controllerOpenWorkshiftModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    openWorkshiftModal,
}: Props) => {
    let recoveredData = window.localStorage.getItem('selection-range');

    if (recoveredData) {
        let data: Array<{ employeeId: string | number; date: string }> =
            JSON.parse(recoveredData);
        if (data.length > 0) {
            openWorkshiftModal('', '', [], false);
        }
    } else {
        let row1 = grid.selectedRanges[0].row;
        let row2 = grid.selectedRanges[0].row2;
        let col1 = grid.selectedRanges[0].col - 2;
        let col2 = grid.selectedRanges[0].col2 - 2;

        if (row1 > row2) {
            let aux = row1;
            row1 = row2;
            row2 = aux;
        }

        if (col1 > col2) {
            let aux = col1;
            col1 = col2;
            col2 = aux;
        }

        let initDate = getDatesBetweenDates(startDate, endDate)[col1];
        let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

        let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);

        if (initDate && lastDate && selectedEmployees.length > 0) {
            openWorkshiftModal(initDate, lastDate, selectedEmployees, false);
        }
    }
};
